import { AccountSelection } from '@juvare/badging/ui/features/badge-management/components/BadgeAccountsSelectionPanel/types';
import { ManageBadgesPanelProps } from '@juvare/badging/ui/features/badge-management/ManageBadgesPanel';
import { AccountColumns } from '@juvare/contact-management/backend/features/accounts/shared';
import { Row } from '@juvare/platform-shared/features/storage';

export const mapAccountToAccountSelection: NonNullable<ManageBadgesPanelProps['mapAccountToAccountSelection']> = (
    row: Row<AccountColumns>,
): AccountSelection => {
    const account = row.columns;
    return {
        id: row.id,
        account,
        options: {},
    };
};
